import {apiGet, apiPost} from "../../../../services/apiClient";

export const getRepresentations = (name) => {
  return apiGet(`${name}/grid/views/list`);
}

export const createRepresentations = (name, data) => {
  return apiPost(`${name}/grid/views/save`, data);
}

export const deleteRepresentations = (name, id) => {
  return apiPost(`${name}/grid/views/${id}/delete`);
}


// WEBPACK FOOTER //
// ./App/pages/reports/components/representation/api.jsx